/**
 * ReportActions Component - Action buttons for reports (CSV, PDF, etc.)
 */
import React from 'react';
import { Button } from '../ui/button';
import { Download, FileDown, BarChart3, RefreshCw } from 'lucide-react';
import { colors } from './constants';

const ReportActions = ({ 
  onDownloadCSV, 
  onDownloadPDF, 
  onBackToOptions, 
  onResetAll 
}) => {
  return (
    <div className="flex flex-col sm:flex-row gap-4">
      <Button 
        className="flex-1" 
        data-testid="download-csv-button" 
        style={{ background: colors.blue }}
        onClick={onDownloadCSV}
      >
        <Download className="mr-2 h-4 w-4" />
        CSV herunterladen
      </Button>
      <Button 
        className="flex-1" 
        data-testid="download-pdf-button" 
        style={{ background: colors.dark }}
        onClick={onDownloadPDF}
      >
        <FileDown className="mr-2 h-4 w-4" />
        PDF Zusammenfassung
      </Button>
      <Button 
        variant="outline" 
        onClick={onBackToOptions} 
        className="flex-1" 
        data-testid="other-report-button"
        style={{ borderColor: colors.blue, color: colors.blue }}
      >
        <BarChart3 className="mr-2 h-4 w-4" />
        Anderer Report
      </Button>
      <Button 
        variant="outline" 
        onClick={onResetAll} 
        className="flex-1" 
        data-testid="new-report-button"
      >
        <RefreshCw className="mr-2 h-4 w-4" />
        Neue Datei
      </Button>
    </div>
  );
};

export default ReportActions;
